import { useEffect, useState } from 'react'
import 'react-reflex/styles.css'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DocNoteTabPanel } from '../../review/DocNoteTabPanel'

interface FreeTalkingRightBodyProps {
  iframeRef: any
  lesson: any
  currentUser: any
  ringleDocToken: any
}

const FreeTalkingRightBody = ({ iframeRef, lesson, currentUser, ringleDocToken }: FreeTalkingRightBodyProps) => {
  const { t } = useTranslation()
  const [documentUrl, setDocumentUrl] = useState('')
  const [ringledocUrl, setRingledocUrl] = useState('')

  useEffect(() => {
    if (lesson && lesson.document_url) {
      setDocumentUrl(lesson.document_url)
    }
    if (lesson && lesson.ringledoc_url) {
      setRingledocUrl(lesson.ringledoc_url)
    }
  }, [])

  return (
    <div>
      <DocNoteTabPanel
        documentUrl={documentUrl}
        ringledocUrl={ringledocUrl}
        iframeRef={iframeRef}
        ringleDocToken={ringleDocToken}
        currentUser={currentUser}
        specialLesson={lesson?.special_lesson}
        height={'calc(100vh - 123px)'}
        style={'border-0 w-h-full w-full h-full'}
      />
    </div>
  )
}

export default FreeTalkingRightBody
